import React from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { theme as defaultTheme } from "../../template/Theme";
import colors from "../../template/Colors";
import { observer } from "mobx-react-lite";
import { inject } from "mobx-react";

const StyledCheckboxAtendimento = observer((props) => {
  const { color, label, checked, openDrawer, disabled, atendimentoStore, id, ...others } = props;
  const colorSelected = colors.commons[color];
  const colorLight = colors.commons[`${color}Light`];
  const isDayView = atendimentoStore.typeCalendarViewSelected === 'dayView'
  const value = atendimentoStore?.relatorioAgendamentos.find((item) => item.situacao === label.toUpperCase())
  const labelFormated = !openDrawer || !isDayView ? label : `${label} : ${value?.quantidade || 0}`

  return (
    <MuiThemeProvider
      theme={
        colorSelected
          ? {
              ...defaultTheme,
              overrides: {
                ...defaultTheme.overrides,
                MuiFormControlLabel: {
                  root: {
                    borderRadius: "100px",
                    backgroundColor: colorLight,
                    color: colorSelected,
                    margin: "5px 0 !important",
                    width: "min-content",
                  },
                  label: {
                    color: colorSelected,
                    padding: "0 5px",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: "10px !important",
                    textWrap: 'nowrap'
                  },
                },
                MuiCheckbox: {
                  root: {
                    padding: 0,
                    color: `${colorSelected} !important`,
                    borderRadius: "50px !important",
                    backgroundColor: colorLight,
                    "&$checked": {
                      color: `${colorSelected} !important`,
                      backgroundColor: `${colorSelected}`,
                    },
                    "&$disabled": {
                      color: `${colorSelected} !important`,
                      backgroundColor: `${colorSelected}`,
                    },
                  },
                },
                MuiIconButton: {
                  label: {
                    borderRadius: 100,
                    width: 10,
                    height: 10,
                    border: `2px solid ${colorSelected}`,

                    "& checked": {
                      backgroundColor: colorSelected,
                      borderRadius: 100,
                      width: 10,
                      height: 10,
                    },
                  },
                },
                MuiSvgIcon: {
                  root: {
                    display: "none",
                  },
                },
              },
            }
          : defaultTheme
      }
    >
      <FormControlLabel
        label={labelFormated}
        checked={checked}
        disabled={disabled}
        control={
          <Checkbox
            {...others}
            id={id}
            color={colors.commons[color] ? undefined : color}
          />
        }
      />
    </MuiThemeProvider>
  );
});

export default inject("atendimentoStore")(StyledCheckboxAtendimento);
